import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/all`;

export const ROUTE: RouteDefinition = `${baseRoute}/all`;

export const URL = (): RouteDefinition => `${baseRoute}/all`;
